import { render, staticRenderFns } from "./LanguageManagersList.vue?vue&type=template&id=88cf9610"
import script from "./LanguageManagersList.vue?vue&type=script&lang=js"
export * from "./LanguageManagersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports